import React from "react";

import { RatingGraphic } from "../../../common/RatingGraphic";
import {
    IReviewQueryFacets,
    ISearchFacetOption,
} from "../../../models/reviews";
import { formatNumber } from "../../../utils/format";
import { parseFacetValues } from "../../../utils/reviews";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { defaultState } from "../defaults";
import { updateFilterOptionValue } from "../reducers";

interface IProps {
    facetType: IReviewQueryFacets;
    option: ISearchFacetOption;
    starHasStroke?: boolean;
}

export const RatingFilterOption = (props: IProps) => {
    const dispatch = useAppDispatch();

    const isChecked = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        const values = parseFacetValues(
            reviewsState.ui.facetValues[props.facetType] || "",
        );
        return values.includes(`${props.option.option_id}`);
    });

    const inputID =
        `${props.facetType}-${props.option.option_id}`.toLowerCase();
    return (
        <div className="customer-review__side-filters__star-rating">
            <div className="customer-review__side-filters__radio-button">
                <input
                    id={inputID}
                    type="checkbox"
                    value={props.option.option_id}
                    checked={isChecked}
                    aria-label={`${props.option.option_id} of 5 star rating`}
                    onChange={(e) => {
                        dispatch(
                            updateFilterOptionValue({
                                facetType: props.facetType,
                                optionID: props.option.option_id,
                                isSelected: e.currentTarget.checked,
                            }),
                        );
                    }}
                />
            </div>
            <label
                htmlFor={inputID}
                className="customer-review__side-filters__stars"
            >
                <RatingGraphic
                    cardClass="product-reviews-filter"
                    cardSize="small"
                    rating={props.option.option_id}
                    onlyStars={true}
                    starHasStroke={props.starHasStroke}
                />
            </label>
            <div className="customer-review__side-filters__number">
                ({formatNumber(props.option.quantity)})
            </div>
        </div>
    );
};
